import React from "react";
import { useField } from "formik";
import { Error } from "@/Components/formik-steps/Error";

export default function TextInput({
  className = "",
  check = true,
  onChange = function () { },
  onError = function () { },
  beforeChangeEvent = function (e) {
    return e;
  },
  ...props
}) {
  const [field, meta] = useField({
    name: props.name,
  });

  if (!props.name) {
    console.warn("Formik text input is declared but name is required");
    return null;
  }

  let errorVisibility = false;

  if (!props.placeholder && props.label) {
    props.placeholder = props.label;
  }

  if (meta.error && meta.touched) {
    errorVisibility = true;
    onError(true);
  }

  function onChangeValue(e) {
    e = beforeChangeEvent(e);

    if (props.max) {
      if (e.target.value <= props.max) {
        field.onChange(e);
        onChange(e.target.value);
      }
    } else {
      field.onChange(e);
      onChange(e.target.value);
    }
  }

  return (
    <div
      className={
        "w-full relative " + (className ? " " + className : "")
      }>
      <div className="relative space-y-4">
        <input
          className={`w-full rounded-[12px] px-4 py-[17px] leading-none
                text-[16px] text-[#323232] placeholder:text-[17px] placeholder:text-[#5C5C5C]
                border ${errorVisibility
              ? "border-[#E30000] bg-[#FFF2F4]"
              : "border-[#E1E0E0] bg-white"
            }
              appearance-none focus:outline-none focus:ring-0 peer text-[17px]`}
          type={props.type || "text"}
          placeholder={props.placeholder}
          {...field}
          {...props}
          onChange={onChangeValue}
        />

        {props.label && (
          <label
            htmlFor={props.name}
            className="absolute select-none text-[17px] text-[#666] duration-300 transform -translate-y-4 
              scale-75 top-4 md:top-4 z-5 origin-[0] left-[15px] md:left-[17px] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 
              peer-focus:scale-75"
          >
            {field.value ? props.label : field.value}
          </label>
        )}
      </div>

      
      {errorVisibility && (
        <div className="py-2">
          <Error message={meta.error} />
        </div>
      )}
      
    </div>
  );
}
